import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    const canonicalUrl = 'https://spotyourdeal.com/contact'; // canonical URL
  
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'canonical');
    this.renderer.setAttribute(link, 'href', canonicalUrl);
    this.renderer.appendChild(document.head, link);
  }

}
